import { FeedState, ScanLogType } from "../../app.enums";
import { modalMessage } from "../../app.modal-messages";
import { MilkBankProductModel } from "../../models/milk-bank-product.model";
import { MilkBottleModel } from "../../models/milk.model";
import {
	ScanMilkBankProductValidationError,
	ScanMilkBottleValidationError,
} from "./scan-validation-error";
import { IScanValidation } from "./scan-validation.model";

/**
 * Verify the state of the product matches the workflow.
 *
 * For example: `CheckStateMatch(MilkState.Frozen)` would throw an error
 * if the milk state is not frozen.
 */
export function CheckStateMatch(state: FeedState) {
	return function (
		target: any,
		propertyKey: string,
		descriptor: PropertyDescriptor
	) {
		const originalMethod = descriptor.value;

		descriptor.value = function (...args: IScanValidation[]) {
			const [obj] = args;

			if (obj.milkBottle instanceof MilkBottleModel) {
				if (state !== obj.milkBottle.milkState) {
					throw new ScanMilkBottleValidationError(
						ScanLogType.Milk_Bottle_Incompatible_State,
						modalMessage.state_mismatch(obj.milkBottle.milkState)
					);
				}
			}

			if (obj.milkBankProduct instanceof MilkBankProductModel) {
				if (state !== obj.milkBankProduct.productState) {
					throw new ScanMilkBankProductValidationError(
						ScanLogType.Product_Incompatible_State,
						modalMessage.state_mismatch(
							obj.milkBankProduct.productState
						)
					);
				}
			}

			return originalMethod.apply(this, args);
		};
	};
}
